const Equipotel2025Translation = {
    _equipotel2025CampaignTitle: {
        pt_br: 'Quer garantir um cofre exclusivo só para você?',
        en_us: "",
        es_es: ""
    },

    _equipotel2025CampaignSubtitle: {
        pt_br: 'Confira como participar:',
        en_us: "",
        es_es: ""
    },

    _equipotel2025Step1: {
        pt_br: "Inscreva-se pelo botão no fim da página",
        en_us: "",
        es_es: ""
    },

    _equipotel2025Step2: {
        pt_br: "Você vai receber um código exclusivo por e-mail",
        en_us: "",
        es_es: ""
    },

    _equipotel2025Step3: {
        pt_br: "Visite nosso stand durante o evento",
        en_us: "",
        es_es: ""
    },

    _equipotel2025Step4: {
        pt_br: "Tente advinhar a senha para abrir o cofre",
        en_us: "",
        es_es: ""
    },

    _equipotel2025Step5: {
        pt_br: "Acertou a senha? O prêmio é seu!",
        en_us: "",
        es_es: ""
    },


    _equipotel2025CampaignRulesTitle: {
        pt_br: "Confira as regras:",
        en_us: "",
        es_es: ""
    },

    _equipotel2025Rule1: {
        pt_br: "Você pode se inscrever até o dia 15 de setembro – não perca o prazo!",
        en_us: "",
        es_es: ""
    },

    _equipotel2025Rule2: {
        pt_br: "Vale só uma inscrição por pessoa (um e-mail e um documento)",
        en_us: "",
        es_es: ""
    },

    _equipotel2025Rule3: {
        pt_br: "Para participar, basta mostrar o código exclusivo que será enviado para o seu e-mail depois da inscrição",
        en_us: "",
        es_es: ""
    },

    _equipotel2025Rule4: {
        pt_br: "O código é pessoal e intransferível",
        en_us: "",
        es_es: ""
    },

    _equipotel2025Rule5: {
        pt_br: "Cada participante terá direito a apenas uma tentativa para abrir o cofre",
        en_us: "",
        es_es: ""
    },

    _equipotel2025Rule6: {
        pt_br: "O código será válido somente durante os dias do evento",
        en_us: "",
        es_es: ""
    },

    _equipotel2025Rule7: {
        pt_br: "O prêmio não poderá ser trocado por dinheiro ou outro item",
        en_us: "",
        es_es: ""
    },

    _equipotel2025AcceptTerms: {
        pt_br: "Li e aceito os termos e regras da campanha",
        en_us: "",
        es_es: ""
    },

    _equipotel2025SignUpSuccessfully: {
        pt_br: "Inscrição confirmada! Seu código exclusivo já foi enviado para o e-mail informado. Guarde bem, você vai precisar dele no evento!",
        en_us: "",
        es_es: ""
    },

    _equipotel2025ErrorOnTrySignUpAlreadyExists: {
        pt_br: "Você já tem uma inscrição ativa! Cada pessoa pode se inscrever apenas uma vez. Use o código enviado para o seu e-mail para participar",
        en_us: "",
        es_es: ""
    },

    _equipotel2025ErrorOnTrySignUpDefault: {
        pt_br: "Ops! Algo deu errado com sua inscrição. Confira os dados informados e tente novamente",
        en_us: "",
        es_es: ""
    },
};

export default Equipotel2025Translation;